import colors from '../../../../../lib/colors'

import { button } from '../../../../../component/component'

export default function(o,c){

  var set = function(roll){
    div.replaceWith(
      div = button(roll,'custom-roll',true,colors.yellow.s_600)
    )
  }

  var setSequence = function(tag){
    div.replaceWith(
      div = button(tag,'fi-price-tag',true,colors.yellow.s_600)
    )
  }

  var div =
    button('000-00','custom-roll',true)

  div.set = set
  div.setSequence = setSequence

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/roll/roll.js